import ReactModal from "react-modal";

import styles from './styles.module.scss'
import { TermoDeUso } from "./TermoDeUso";

interface TermosDeUsoModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onAcept: () => void;
}
export function TermosDeUsoModal({ isOpen, onRequestClose, onAcept }: TermosDeUsoModalProps) {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content">
      <>
        <div className={styles.modal_title}>
          <h2>TERMO DE CONSENTIMENTO</h2>
        </div>
        <div className={styles.modal_content}>
          <TermoDeUso />
        </div>
        <div className={styles.modal_actions}>
          <button
            type="button"
            className={styles.nao_aceito}
            onClick={onRequestClose}>
            Não aceito
          </button>

          <button
            type="button"
            className={styles.aceito}
            onClick={onAcept}
          >
            Aceito
          </button>

        </div>
      </>
    </ReactModal>
  )
}